import { WalletInputValues } from '../types/Wallet/input-values';

const WALLET_SUGGESTED_VALUES_SAR: Array<WalletInputValues> = [
  {
    value: '100',
    selected: false,
  },
  {
    value: '500',
    selected: false,
  },
  {
    value: '1000',
    selected: false,
  },
  {
    value: '5000',
    selected: false,
  },
];

const WALLET_SUGGESTED_VALUES_UAE: Array<WalletInputValues> = [
  {
    value: '100',
    selected: false,
  },
  {
    value: '500',
    selected: false,
  },
  {
    value: '1000',
    selected: false,
  },
  {
    value: '4500',
    selected: false,
  },
];

const WALLET_SUGGESTED_VALUES_KWD: Array<WalletInputValues> = [
  {
    value: '10',
    selected: false,
  },
  {
    value: '50',
    selected: false,
  },
  {
    value: '100',
    selected: false,
  },
  {
    value: '450',
    selected: false,
  },
];

const WALLET_SUGGESTED_VALUES_QAR: Array<WalletInputValues> = [
  {
    value: '100',
    selected: false,
  },
  {
    value: '500',
    selected: false,
  },
  {
    value: '1000',
    selected: false,
  },
  {
    value: '4500',
    selected: false,
  },
];

const WALLET_SUGGESTED_VALUES_OMR: Array<WalletInputValues> = [
  {
    value: '10',
    selected: false,
  },
  {
    value: '50',
    selected: false,
  },
  {
    value: '100',
    selected: false,
  },
  {
    value: '550',
    selected: false,
  },
];

const WALLET_SUGGESTED_VALUES_BHD: Array<WalletInputValues> = [
  {
    value: '10',
    selected: false,
  },
  {
    value: '50',
    selected: false,
  },
  {
    value: '100',
    selected: false,
  },
  {
    value: '500',
    selected: false,
  },
];

export const WALLET_SUGGESTED_VALUES = [
  { currency: 'SAR', values: WALLET_SUGGESTED_VALUES_SAR },
  { currency: 'AED', values: WALLET_SUGGESTED_VALUES_UAE },
  { currency: 'KWD', values: WALLET_SUGGESTED_VALUES_KWD },
  { currency: 'QAR', values: WALLET_SUGGESTED_VALUES_QAR },
  { currency: 'OMR', values: WALLET_SUGGESTED_VALUES_OMR },
  { currency: 'BHD', values: WALLET_SUGGESTED_VALUES_BHD },
];

export const WALLET_WITHDRAWAL_FEE_THRESHOLD = 20000;
